import { StylePanelPlane } from './types';

export const MAX_INPUT_VALUE = 9999;
export const MOUSE_QUICK_CHANGE = '$globalMouseQuickChange';
export const KEYBOARD_QUICK_CHANGE = '$globalKeyboardQuickChange';
export const DEFAULT_PLANE: StylePanelPlane = StylePanelPlane.Vertical;
